import { Injectable } from "@angular/core";
import { gql, Query, Apollo, Mutation } from "apollo-angular";
import { IdeaAuthor } from "./idea-author.graphql";

export type GetAuthorsByIdeaQuery = {
  getAuthorsByIdea: {
    authorName: string;
    email: string;
    role: string;
    document: string;
    re: string;
    areaResponsible: string;
    costCenter?: string;
    authors: Array<{
      id: string;
      re: string;
      name: string;
      email: string;
      costCenter?: string;
      cpf: string;
      area: string;
      remove: boolean;
      jobRole: string;
    }>;
  };
};

export type GetAuthorsByIdeaQueryVariables = {
  id: string;
};

export const getAuthorsByIdeaDocument = gql`
  query GetAuthorsByIdea($id: String!) {
    getAuthorsByIdea(id: $id) {
      authorName
      email
      re
      document
      role
      areaResponsible
      costCenter
      authors {
        id
        re
        name
        email
        costCenter
        cpf
        remove
        area
        jobRole
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAuthorsByIdeaGQL extends Query<
  GetAuthorsByIdeaQuery,
  GetAuthorsByIdeaQueryVariables
> {
  document = getAuthorsByIdeaDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}

export type UpdateAuthorsMutation = {
  updateAuhtorsByIdIdea: {
    ideaAuthors: IdeaAuthor[];
    message: string;
  };
};

export type UpdateAuthorsMutationVariables = {
  id: string;
  authorsInput: Array<{
    id: string;
    name: string;
    re: string;
    email: string;
    remove?: boolean;
    costCenter: string;
    jobRole: string;
    cpf: string;
    area: string;
    edit: boolean;
    isMain: boolean;
    setMain: boolean;
    justification: string;
    changed: boolean;
    active: boolean;
    parent?: { id: string; name: string };
  }>;
};

export const updateAuthorsDocument = gql`
  mutation UpdateAuthors($id: String!, $authorsInput: [AuthorInput!]!) {
    updateAuthorsByIdIdea(
      updateAuthorsInput: { id: $id, authorsInput: $authorsInput }
    ) {
      ideaAuthors {
        id
      }
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateAuthorsGQL extends Mutation<
  UpdateAuthorsMutation,
  UpdateAuthorsMutationVariables
> {
  document = updateAuthorsDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
